/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 795
// module chunks = 1